import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './FlexpassDatesModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassDatesModal extends Component {

	toggle = () => {
		this.props.toggleDatesModal();
	}

	componentWillReceiveProps(props) {
		props.flexpassDetails.prices.forEach((price) => {
			setTimeout(() => {
				const select = document.getElementById('price-' + price.id);
				if(select !== null){
					[...select.options].some((option, index) => {
						if (option.value === price.value) {
							select.selectedIndex = index;
							return true;
						}
					});
				}
			}, 500);
		});
	}

	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isDatesModalOpen} toggle={this.toggle} className="modal-price-change">
		          	<ModalHeader toggle={this.toggle}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<div className="table-responsive">
							<table className="showtix-table showtix-table__theme2">
								<thead>
									<tr>
										<th className="text-center"></th>
										{ this.props.flexpassDetails.prices.map((price, i) =>
											[
												(price.name !== "" &&
												<th className="text-center" key={i}>
													{price.name}&nbsp;
													-&nbsp;
													{new Intl.NumberFormat('en-US', { 
														style: 'currency', 
														currency: 'USD' 
													}).format(price.price)}	
												</th>
												)
											]
										)}
									</tr>
								</thead>
								<tbody>
									{/* { this.props.event.venue.sections.map((section, i) => */}
										<tr>
											<td className="text-left">
												Flexpass
											</td>
											{ this.props.flexpassDetails.prices.map((price, j) =>
												[
													(price.name !== "" &&
													<td className="text-center" key={j}>
														<div className="showtix-form__group">
															<div className="showtix-form__select">
																<select
																	className="showtix-input js-section-price"
																	price={price.id} 
																	id={"price-" + price.id}
																>
																	<option value="all">{strings.both}</option>
																	<option value="box-office">{strings.boxOfficeOnly}</option>
																	<option value="hidden">{strings.noOne}</option>
																</select>
															</div> 
														</div>
													</td>
													)
												]
											)}
										</tr>
									{/* )} */}
									
								</tbody>
							</table>
						</div> 
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.savePricing}
						>
							<span>{strings.saveClose}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

FlexpassDatesModal.propTypes = {
    event: PropTypes.shape({
        venue: PropTypes.shape({
            sections: PropTypes.array
        }),
        prices: PropTypes.array
    }),
    isDatesModalOpen: PropTypes.bool,
    toggleDatesModal: PropTypes.func,
    savePricing: PropTypes.func
}
 
export default FlexpassDatesModal;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/FlexpassDatesModal/FlexpassDatesModal.js